import React from "react";

import { useContentColor } from "../../../styles/colors/content/useContentColor";
import { ContentEmphasis, KeyColorRole } from "../../../styles/colors/types";
import { IconName, iconNameMap } from "../../../styles/icons/icons";
import { iconSizeMap } from "./consts";

import type { IconSize } from "./consts";

type Props = {
  iconName: IconName;
  accessibilityLabel: string | null;
  size?: IconSize;
  tone?: KeyColorRole;
  emphasis?: ContentEmphasis;
  onHighEmphasisSurface?: boolean;
};

export default function Icon({
  iconName,
  accessibilityLabel,
  size = "medium",
  tone,
  emphasis = "high",
  onHighEmphasisSurface = false
}: Props) {
  const color =
    tone && useContentColor({ tone, emphasis, onHighEmphasisSurface });

  const accessibilityProp = accessibilityLabel
    ? { "aria-label": accessibilityLabel }
    : { "aria-hidden": true };

  const Component = iconNameMap[iconName];

  return (
    <Component
      {...iconSizeMap[size]}
      color={color}
      display="block"
      {...accessibilityProp}
    />
  );
}
